import React, {useRef, useState} from 'react'
import {NavLink, useLocation } from 'react-router-dom';
import useAuth from '../../auth/useAuth';
import routes from '../../routers/helpers/routes';
import EmailModal from './EmailModal';


export default function NavHome(props) {

  const location = useLocation();
  const btnSesion = location.pathname.includes('/dashboard') ? 'Cerrar Sesión' : 'Inicia Sesión';
  const activeDashboard = location.pathname.includes('/dashboard') ? 'nav-link active' : 'nav-link';
  const activeHome = location.pathname === '/' ? 'nav-link active' : 'nav-link';
  const activeLogin = location.pathname === '/login' ? 'nav-link active' : 'nav-link';
  const activeRegister = location.pathname.includes('/register') ? 'nav-link active' : 'nav-link';


  const {user} = useAuth();
  const toggle = props.toggleSidebar;
  const position = toggle ? 'sticky' : '';
  const top = toggle ? 0 : '';
  const [stateTogle, setStateToggle] = useState(false)

  const btnToggle = useRef();

  const clickToggle = () => {
    btnToggle.current.click();
  }

  const width = props.width
  let display = !stateTogle && width > 995 ? 'contents': 'none';
  if(stateTogle || width > 995) display = 'contents'

  const handleToggle = () => {
    setStateToggle(!stateTogle);
  }

  const handleSession = async() => {
    if(btnSesion === 'Cerrar Sesión'){
      window.localStorage.clear();
      await props.logout();
    } else {
      clickToggle();
    }
  }

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark bg-dark"
      style={{ position: `${position}`, top: `${top}` }}
    >
      <div className="container" style={{ paddingLeft: "initial" }}>
        {/* <NavLink to  variant = "dark" bg='dark'>
            <img alt="Logo SMS-APP" className="rounded-circle" style= {{width: '15%'}} src="/SMS-APP.png" /> SMS-APP
          </NavLink>   */}
        <a href={routes.home} variant="dark" bg="dark">
          <img
            alt="Logo SMS-APP"
            className="rounded-circle"
            style={{ width: "15%" }}
            src="/SMS-APP.png"
          />{" "}
          SMS-APP
        </a>

        <button
        ref={btnToggle}
          onClick={handleToggle}
          className="navbar-toggler mt-2"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div
          style={{ display: `${display}` }}
          className="collapse show"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav ms-3 mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                onClick={clickToggle}
                id="home"
                className={activeHome}
                aria-current="page"
                to={routes.home}
            
              >
                Home
              </NavLink>
            </li>
            {user?.name !== "" && (
              <li className="nav-item">
                <NavLink
                  onClick={clickToggle}
                  id="dashboard"
                  className={activeDashboard}
                  to={routes.dashboard + "/" + routes.dashboardUser}
                >
                  Dashboard
                </NavLink>
              </li>
            )}
           
            {user?.name === "" && (
            <li className="nav-item">
              <a onClick={clickToggle} className={activeRegister} href="#emailModal" role="button" data-bs-toggle="modal">
                Registro
              </a>
            </li>)}


            <li className="nav-item">
              <NavLink
                id="sesion"
                onClick={handleSession}
                className={activeLogin}
                to={routes.login}
              >
                {btnSesion}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
      <div id="emailModal" className="modal fade" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content font-mulish">
            <EmailModal />
          </div>
        </div>
      </div>
    </nav>
  );
}